// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  html, body {
    margin: 0;
    padding: 0;
  }

  /* src/components/Header.css */
.app-header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 0.75rem 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  animation: fadeInDown 0.5s ease-out;
  border: none !important;
  border-radius: 0 !important;

}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

.logo-link {
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.03);
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2168da;
  margin: 0;
  transition: all 0.3s ease;
}

.logo-accent {
  color: #fbbf24;
  transition: color 0.3s ease;
}

.auth-buttons {
  display: flex;
  gap: 0.5rem;
}

.auth-button {
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 0.9rem;
}

.login-button {
  background: white;
  color: #2563eb;
  border: 2px solid #2563eb;
}

.login-button:hover {
  background: #dbeafe;
  transform: translateY(-2px);
  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);
}

.signup-button {
  background: linear-gradient(to right, #2563eb, #4f46e5);
  color: white;
  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);
}

.signup-button:hover {
  background: linear-gradient(to right, #1d4ed8, #4338ca);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);
}

/* Mobile menu button */
.menu-toggle {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.menu-icon {
  width: 24px;
  height: 24px;
  color: #1e293b;
}

/* Responsive styles */
@media (max-width: 768px) {
  .app-header {
    padding: 0.5rem 1rem;
  }
  
  .logo {
    font-size: 1.3rem;
  }
  
  .auth-buttons {
    position: fixed;
    top: 0px;
    right: 0;
    background: white;
    flex-direction: column;
    width: 100%;
    padding: 1rem;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-150%);
    transition: transform 0.4s ease;
    z-index: 99;
  }
  
  .auth-buttons.open {
    transform: translateY(0);
  }
  
  .menu-toggle {
    display: block;
  }
  
  .auth-button {
    width: 100%;
    padding: 0.8rem;
    text-align: center;
    margin: 0.25rem 0;
  }
}

@media (min-width: 769px) {
  .auth-buttons {
    display: flex !important;
    position: static;
    flex-direction: row;
    width: auto;
    padding: 0;
    box-shadow: none;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"EAAE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA,8BAA8B;AAChC;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mCAAmC;EACnC,uBAAuB;EACvB,2BAA2B;;AAE7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,4BAA4B;IAC5B,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["  html, body {\n    margin: 0;\n    padding: 0;\n  }\n\n  /* src/components/Header.css */\n.app-header {\n  background: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 0.75rem 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  animation: fadeInDown 0.5s ease-out;\n  border: none !important;\n  border-radius: 0 !important;\n\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.logo-link {\n  text-decoration: none;\n  transition: transform 0.3s ease;\n}\n\n.logo-link:hover {\n  transform: scale(1.03);\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2168da;\n  margin: 0;\n  transition: all 0.3s ease;\n}\n\n.logo-accent {\n  color: #fbbf24;\n  transition: color 0.3s ease;\n}\n\n.auth-buttons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.auth-button {\n  padding: 0.5rem 1rem;\n  border-radius: 50px;\n  font-weight: 600;\n  font-family: 'Poppins', sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  font-size: 0.9rem;\n}\n\n.login-button {\n  background: white;\n  color: #2563eb;\n  border: 2px solid #2563eb;\n}\n\n.login-button:hover {\n  background: #dbeafe;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);\n}\n\n.signup-button {\n  background: linear-gradient(to right, #2563eb, #4f46e5);\n  color: white;\n  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);\n}\n\n.signup-button:hover {\n  background: linear-gradient(to right, #1d4ed8, #4338ca);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);\n}\n\n/* Mobile menu button */\n.menu-toggle {\n  display: none;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.menu-icon {\n  width: 24px;\n  height: 24px;\n  color: #1e293b;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .app-header {\n    padding: 0.5rem 1rem;\n  }\n  \n  .logo {\n    font-size: 1.3rem;\n  }\n  \n  .auth-buttons {\n    position: fixed;\n    top: 0px;\n    right: 0;\n    background: white;\n    flex-direction: column;\n    width: 100%;\n    padding: 1rem;\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n    transform: translateY(-150%);\n    transition: transform 0.4s ease;\n    z-index: 99;\n  }\n  \n  .auth-buttons.open {\n    transform: translateY(0);\n  }\n  \n  .menu-toggle {\n    display: block;\n  }\n  \n  .auth-button {\n    width: 100%;\n    padding: 0.8rem;\n    text-align: center;\n    margin: 0.25rem 0;\n  }\n}\n\n@media (min-width: 769px) {\n  .auth-buttons {\n    display: flex !important;\n    position: static;\n    flex-direction: row;\n    width: auto;\n    padding: 0;\n    box-shadow: none;\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
